{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Kairiojoje srityje pasirinkite pokalbį",
    "CSAT_REPLY_MESSAGE": "Prašome įvertinti pokalbį",
    "404": "Atsiprašome, negalime rasti pokalbio. Prašau, pabandykite dar kartą",
    "SWITCH_VIEW_LAYOUT": "Perjunkite išdėstymą",
    "DASHBOARD_APP_TAB_MESSAGES": "Pranešimai",
    "UNVERIFIED_SESSION": "Šio vartotojo tapatybė nepatvirtinta",
    "NO_MESSAGE_1": "Oi! Panašu, kad jūsų gautų laiškų aplanke nėra pranešimų iš klientų.",
    "NO_MESSAGE_2": " norėdami išsiųsti žinutę į savo puslapį!",
    "NO_INBOX_1": "Sveiki! Panašu, kad dar nepridėjote jokių gautųjų laiškų aplanko.",
    "NO_INBOX_2": " norint pradėti",
    "NO_INBOX_AGENT": "Oi! Atrodo, kad nesate jokio gautų laiškų aplanko dalis. Susisiekite su administratoriumi",
    "SEARCH_MESSAGES": "Ieškokite pranešimų pokalbiuose",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "norėdami atidaryti komandų meniu",
      "KEYBOARD_SHORTCUTS": "norėdami peržiūrėti sparčiuosius klavišus"
    },
    "SEARCH": {
      "TITLE": "Ieškoti pranešimų",
      "RESULT_TITLE": "Rezultatų Paieška",
      "LOADING_MESSAGE": "Duomenys apdorojami...",
      "PLACEHOLDER": "Parašykite tekstą pranešimų paieškai",
      "NO_MATCHING_RESULTS": "Nieko nerasta."
    },
    "UNREAD_MESSAGES": "Neperskaitytos žinutės",
    "UNREAD_MESSAGE": "Neperskaityta žinutė",
    "CLICK_HERE": "Paspausti čia",
    "LOADING_INBOXES": "Įkeliami gautų laiškų aplankai",
    "LOADING_CONVERSATIONS": "Pokalbiai parsiunčiami",
    "CANNOT_REPLY": "Jūs negalite atsakyti dėl",
    "24_HOURS_WINDOW": "Pranešimų apribojimas 24 valandoms",
    "48_HOURS_WINDOW": "Pranešimų apribojimas 48 valandoms",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "Šis pokalbis jums nepriskirtas. Ar norėtumėte priskirti šį pokalbį sau?",
    "ASSIGN_TO_ME": "Priskirti man",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "Į šį pokalbį galite atsakyti tik naudodami šablono pranešimą, nes",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Pranešimų apribojimas 24 valandoms",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "REPLYING_TO": "Jūs atsakote į:",
    "REMOVE_SELECTION": "Pašalinti Pasirinkimą",
    "DOWNLOAD": "Parsisiųsti",
    "UNKNOWN_FILE_TYPE": "Nežinomas failas",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file",
      "MEETING": "{sender} pradėjo susitikimą"
    },
    "UPLOADING_ATTACHMENTS": "Įkeliami priedai...",
    "REPLIED_TO_STORY": "Atsakė į tavo pasakojimą",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Ši žinutė nepalaikoma. Jūs galite peržiūrėti šią žinutę Facebook Messenger programėlėje.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Ši žinutė nepalaikoma. Jūs galite peržiūrėti šią žinutę Instagram programėlėje.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "Pranešimas ištrintas sėkmingai",
    "FAIL_DELETE_MESSSAGE": "Nepavyko ištrinti pranešimo! Bandykite dar kartą",
    "NO_RESPONSE": "Nėra atsakymo",
    "RESPONSE": "Response",
    "RATING_TITLE": "Reitingas",
    "FEEDBACK_TITLE": "Grįžtamasis ryšys",
    "REPLY_MESSAGE_NOT_FOUND": "Pranešimas nepasiekiamas",
    "CARD": {
      "SHOW_LABELS": "Rodyti etiketes",
      "HIDE_LABELS": "Slėpti etiketes",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Išspręsti",
      "REOPEN_ACTION": "Atidarykite iš naujo",
      "OPEN_ACTION": "Atidaryti",
      "MORE_ACTIONS": "More actions",
      "OPEN": "Daugiau",
      "CLOSE": "Uždaryti",
      "DETAILS": "smulkesnė informacija",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "Atidėta iki",
      "SNOOZED_UNTIL_TOMORROW": "Atidėta iki rytojaus",
      "SNOOZED_UNTIL_NEXT_WEEK": "Atidėta iki kitos savaitės",
      "SNOOZED_UNTIL_NEXT_REPLY": "Atidėta iki kito atsakymo",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Pažymėti kaip laukiantį",
      "SNOOZE_UNTIL": "Atidėti",
      "SNOOZE": {
        "TITLE": "Atidėti iki",
        "NEXT_REPLY": "Kitas atsakymas",
        "TOMORROW": "Rytoj",
        "NEXT_WEEK": "Kitą savaitę"
      }
    },
    "MENTION": {
      "AGENTS": "Agentai",
      "TEAMS": "Komandos"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Atidėti iki",
      "APPLY": "Atidėti",
      "CANCEL": "Atšaukti"
    },
    "PRIORITY": {
      "TITLE": "Prioritetas",
      "OPTIONS": {
        "NONE": "Nėra",
        "URGENT": "Skubus",
        "HIGH": "Aukštas",
        "MEDIUM": "Vidutinis",
        "LOW": "Žemas"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nėra",
        "INPUT_PLACEHOLDER": "Pasirinkti prioritetą",
        "NO_RESULTS": "Nieko nerasta",
        "SUCCESSFUL": "Prioritetas pokalbiui id {conversationId} pakeistas į {priority}",
        "FAILED": "Nepavyko pakeisti prioriteto. Prašau, pabandykite dar kartą."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "Ištrinti"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "Pažymėti kaip laukiantį",
      "RESOLVED": "Pažymėti kaip išspręstą",
      "MARK_AS_UNREAD": "Pažymėti kaip neperskaitytą",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Atidaryti pokalbį",
      "SNOOZE": {
        "TITLE": "Atidėti",
        "NEXT_REPLY": "Iki kito atsakymo",
        "TOMORROW": "Iki rytojaus",
        "NEXT_WEEK": "Iki kitos savaitės"
      },
      "ASSIGN_AGENT": "Priskirti Agentą",
      "ASSIGN_LABEL": "Priskirti etiketę",
      "AGENTS_LOADING": "Agentai užkraunami...",
      "ASSIGN_TEAM": "Priskirti komandą",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Pokalbis id {conversationId} priskirtas \"{agentName}\"",
          "FAILED": "Nepavyko priskirti agento. Prašau, pabandykite dar kartą."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Nepavyko priskirti etiketės. Prašau, pabandykite dar kartą."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Priskirta komanda \"{team}\" pokalbiui id {conversationId}",
          "FAILED": "Nepavyko priskirti komandos. Prašau, pabandykite dar kartą."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Pranešimo parašas",
      "ENABLE_SIGN_TOOLTIP": "Įjungti parašą",
      "DISABLE_SIGN_TOOLTIP": "Išjungti parašą",
      "MSG_INPUT": "Spauksite Shift + Enter, pradėjimui iš naujos eilutės. Pradėkite nuo „/“, kad pasirinktumėte Atsakymo Ruošinį.",
      "PRIVATE_MSG_INPUT": "Spauksite Shift + Enter, pradėjimui iš naujos eilutės. Tai bus matoma tik Agentams",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Pranešimo parašas nesukonfigūruotas, sukonfigūruokite jį profilio nustatymuose.",
      "COPILOT_MSG_INPUT": "Duokite copiloto papildomų nurodymų arba klauskite dar ko nors... Paspauskite Enter, kad išsiųstumėte papildomą žinutę",
      "CLICK_HERE": "Spausti čia kad atnaujinti",
      "WHATSAPP_TEMPLATES": "Whatsapp Šablonai"
    },
    "REPLYBOX": {
      "REPLY": "Atsakyti",
      "PRIVATE_NOTE": "Privati pastaba",
      "SEND": "Siųsti",
      "CREATE": "Pridėti pastabą",
      "INSERT_READ_MORE": "Skaityti daugiau",
      "DISMISS_REPLY": "Atšaukti atsakymą",
      "REPLYING_TO": "Atsakant į:",
      "TIP_EMOJI_ICON": "Parodyti emodžio parinkiklį",
      "TIP_ATTACH_ICON": "Pridėti failus",
      "TIP_AUDIORECORDER_ICON": "Įrašyti audio",
      "TIP_AUDIORECORDER_PERMISSION": "Leisti prieiti prie audio",
      "TIP_AUDIORECORDER_ERROR": "Nepavyko atidaryti audio",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "Norėdami pridėti, vilkite ir numeskite čia",
      "START_AUDIO_RECORDING": "Pradėti audio įrašymą",
      "STOP_AUDIO_RECORDING": "Baigti audio įrašymą",
      "COPILOT_THINKING": "Copilot galvoja",
      "EMAIL_HEAD": {
        "TO": "Kam",
        "ADD_BCC": "Pridėti bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "El. laiškai atskirti kableliais",
          "ERROR": "Prašau įveskite teisingą el. pašto adresą"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "El. laiškai atskirti kableliais",
          "ERROR": "Prašau įveskite teisingą el. pašto adresą"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Neapibrėžti kintamieji",
        "MESSAGE": "Jūsų pranešime yra {undefinedVariablesCount} neapibrėžtų kintamųjų: {undefinedVariables}. Ar vis tiek norėtumėte išsiųsti žinutę?",
        "CONFIRM": {
          "YES": "Siųsti",
          "CANCEL": "Atšaukti"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "Privati ​​pastaba: matoma tik jums ir jūsų komandai",
    "CHANGE_STATUS": "Pokalbio būsena pakeista",
    "CHANGE_STATUS_FAILED": "Pokalbio būsenos nepavyko pakeisti",
    "CHANGE_AGENT": "Pasikeitė pokalbiui priskirtas asmuo",
    "CHANGE_AGENT_FAILED": "Priskirto asmens pakeitimas nepavyko",
    "ASSIGN_LABEL_SUCCESFUL": "Etiketė sėkmingai priskirta",
    "ASSIGN_LABEL_FAILED": "Etiketės priskirti nepavyko",
    "CHANGE_TEAM": "Pasikeitė pokalbių komanda",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "Failas viršija {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB priedo apribojimą",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "Nepavyko išsiųsti šio pranešimo, bandykite dar kartą vėliau",
    "SENT_BY": "Siuntėjas:",
    "BOT": "Botas",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "Nepavyko išsiųsti pranešimo! Bandykite dar kartą",
    "TRY_AGAIN": "kartoti",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Pasirinkti agentą",
      "REMOVE": "Pašalinti",
      "ASSIGN": "Priskirti"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopijuoti",
      "REPLY_TO": "Atsakyti į šią žinutę",
      "DELETE": "Ištrinti",
      "CREATE_A_CANNED_RESPONSE": "Pridėti Atsakymų Ruošinius",
      "TRANSLATE": "Išversti",
      "COPY_PERMALINK": "Nukopijuoti nuorodą į pranešimą",
      "LINK_COPIED": "Pranešimo URL nukopijuotas į iškarpinę",
      "DELETE_CONFIRMATION": {
        "TITLE": "Ar tikrai norite ištrinti šį pranešimą?",
        "MESSAGE": "Negalite anuliuoti šio veiksmo",
        "DELETE": "Ištrinti",
        "CANCEL": "Atšaukti"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Kontaktas",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "Atsisakyti",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Siųsti poklabio stenogramą",
    "DESC": "Siųsti pokalbio stenogramos kopiją nurodytu el. pašto adresu",
    "SUBMIT": "Pateikti",
    "CANCEL": "Atšaukti",
    "SEND_EMAIL_SUCCESS": "Pokalbio stenograma sėkmingai išsiųsta",
    "SEND_EMAIL_ERROR": "Įvyko klaida, prašau pabandykite dar kartą",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "Siųsti stenogramą klientui",
      "SEND_TO_AGENT": "Siųsti stenogramą priskirtam agentui",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Siųsti stenogramą kitu el. pašto adresu",
      "EMAIL": {
        "PLACEHOLDER": "Įvesti el. pašto adresą",
        "ERROR": "Prašau įveskite teisingą el. pašto adresą"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Sveiki 👋, Sveiki atvykę į {installationName}!",
    "DESCRIPTION": "Ačiū, kad užsiregistravote. Norime, kad išnaudotumėte visas {installationName} galimybes. Štai keletas dalykų, kuriuos galite padaryti naudodami {installationName}, kad patirtis būtų maloni.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Skaitykite mūsų naujausius atnaujinimus",
    "ALL_CONVERSATION": {
      "TITLE": "Visi jūsų pokalbiai vienoje vietoje",
      "DESCRIPTION": "Peržiūrėkite visus savo klientų pokalbius vienoje informacijos suvestinėje. Galite filtruoti pokalbius pagal gaunamą kanalą, etiketę ir būseną.",
      "NEW_LINK": "Spustelėkite čia, kad sukurtumėte gautų laiškų aplanką"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Pakvieskite savo komandos narius",
      "DESCRIPTION": "Kadangi ruošiatės kalbėtis su savo klientu, pasikvieskite savo komandos draugus, kad jie jums padėtų. Galite pakviesti savo komandos draugus įtraukę jų el. pašto adresus į agentų sąrašą.",
      "NEW_LINK": "Spustelėkite čia, kad pakviestumėte komandos narį"
    },
    "LABELS": {
      "TITLE": "Tvarkykite pokalbius etiketėmis",
      "DESCRIPTION": "Etiketės suteikia lengvesnį būdą suskirstyti pokalbį į kategorijas. Sukurkite keletą etikečių, pvz., #palaikymo-klausimas, #atsiskaitymo-klausimas ir kt., kad vėliau galėtumėte jas naudoti pokalbyje.",
      "NEW_LINK": "Spustelėkite čia, kad sukurtumėte žymas"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Priskirtas Agentas",
    "SELF_ASSIGN": "Priskirti man",
    "TEAM_LABEL": "Priskirta komanda",
    "SELECT": {
      "PLACEHOLDER": "Nėra"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "Kontakto detali informacija",
      "CONVERSATION_ACTIONS": "Pokalbio veiksmai",
      "CONVERSATION_LABELS": "Pokalbio Etiketės",
      "CONVERSATION_INFO": "Pokalbio Informacija",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "Kontakto Požymiai",
      "PREVIOUS_CONVERSATION": "Ankstesni pokalbiai",
      "MACROS": "Makrokomandos",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "Peržiūrėti visus",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Laukiama",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Sukurti požymį",
    "NO_RECORDS_FOUND": "Požymių nerasta",
    "UPDATE": {
      "SUCCESS": "Požymis atnaujintas sėkmingai",
      "ERROR": "Nepavyko atnaujinti požymio. Pabandykite dar kartą vėliau"
    },
    "ADD": {
      "TITLE": "Pridėti",
      "SUCCESS": "Požymis pridėtas sėkmingai",
      "ERROR": "Nepavyko pridėti požymį. Pabandykite dar kartą vėliau"
    },
    "DELETE": {
      "SUCCESS": "Požymis ištrintas sėkmingai",
      "ERROR": "Nepavyko ištrinti požymio. Pabandykite dar kartą vėliau"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Pridėti požymius",
      "PLACEHOLDER": "Ieškoti požymių",
      "NO_RESULT": "Požymių nerasta"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Nuo",
    "TO": "Kam",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Tema",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Dalyvaujantys",
    "SIDEBAR_TITLE": "Pokalbio dalyviai",
    "NO_RECORDS_FOUND": "Nieko nerasta",
    "ADD_PARTICIPANTS": "Pasirinkti dalyvius",
    "REMANING_PARTICIPANTS_TEXT": "+{count} kiti",
    "REMANING_PARTICIPANT_TEXT": "+{count} kitas",
    "TOTAL_PARTICIPANTS_TEXT": "{count} dalyvauja žmonių.",
    "TOTAL_PARTICIPANT_TEXT": "{count} dalyvauja asmenų.",
    "NO_PARTICIPANTS_TEXT": "Niekas nedalyvauja!.",
    "WATCH_CONVERSATION": "Prisijungti pire pokalbio",
    "YOU_ARE_WATCHING": "Jūs dalyvaujate",
    "API": {
      "ERROR_MESSAGE": "Nepavyko atnaujinti, bandykite dar kartą!",
      "SUCCESS_MESSAGE": "Dalyviai atnaujinti!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Rodyti išverstą turinį",
    "DESC": "Galite peržiūrėti išverstą turinį kiekviena kalba.",
    "ORIGINAL_CONTENT": "Originalus turinys",
    "TRANSLATED_CONTENT": "Išverstas turinys",
    "NO_TRANSLATIONS_AVAILABLE": "Nėra šio turinio vertimo"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
